import styled from 'styled-components';

export default styled.img`
  max-width: 2.5rem;
`;
